'use client';

import { MyReviewElementDataType } from '@/components/sections/builder/elements/body/customer/customer_review/type';
import { ElementProps } from '@/components/sections/builder/types';
import { usePaginationSearchParams } from '@/hooks/use-pagination';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';
import ListUnReview from '@/components/sections/builder/elements/body/customer/customer_review/components/list-unreviewed';
import ListReviewed from '@/components/sections/builder/elements/body/customer/customer_review/components/list-reviewed';
import { useBuilderStore } from '@/stores/builder';
import React from 'react';
import { shallow } from 'zustand/shallow';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';

const TAB_CONFIGS = [
  {
    value: 'unreviewed',
    label: 'Not Yet Reviewed',
  },
  {
    value: 'reviewed',
    label: 'Already Reviewed',
  },
];

export default function ElementContentMyReview({ element, preview, theme }: ElementProps) {
  const content = element.data as MyReviewElementDataType;
  const [params, setParams] = usePaginationSearchParams();

  React.useEffect(() => {
    if (params.tab === 'total-stock') {
      setParams({ ...params, tab: 'unreviewed', pageIndex: 0 });
    }
  }, [params.tab]);

  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const themeContent = preview ? builder.theme : theme;
  const starColor = themeContent?.productRating?.starColor || DEFAULT_THEME_COLOR_SCHEME.text;

  return (
    <>
      <div className='bg_scheme_customer_detail customer_detail_padding mx-auto w-full '>
        <div className='theme_layout_page_width mx-auto flex flex-col gap-3 px-5'>
          <h1 className='text-2xl font-medium'>My Review</h1>
          <Tabs
            value={params.tab}
            className='relative h-full'
            onValueChange={(value) => {
              setParams({ ...params, tab: value, pageIndex: 0 });
            }}
            defaultValue='unreviewed'
          >
            <TabsList className='relative flex w-full flex-nowrap space-x-2 overflow-x-auto bg-transparent text-xs'>
              {TAB_CONFIGS.map((tab) => (
                <TabsTrigger
                  key={tab.value}
                  className={cn(`inline-flex flex-shrink-0 px-4 py-2 text-sm sm:text-base`)}
                  data-testid={`${tab.value}-tab`}
                  style={
                    params.tab === tab.value
                      ? {
                          color: content.colorScheme?.textSecondary,
                          borderBottomColor: content.colorScheme?.textSecondary,
                        }
                      : {}
                  }
                  isCustom
                  value={tab.value}
                >
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>
            <TabsContent value='unreviewed' className='mt-2 p-0'>
              <div className='relative w-full'>
                <ListUnReview content={content} preview={preview} />
              </div>
            </TabsContent>
            <TabsContent value='reviewed' className='mt-2 p-0'>
              <div className='w-full'>
                <ListReviewed content={content} preview={preview} starColor={starColor} />
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>
      <style jsx>
        {`
          .bg_scheme_customer_detail {
            background-color: ${content.colorScheme?.background || 'white'};
            color: ${content.colorScheme?.text || '#52535B'};
          }
          .customer_detail_padding {
            padding-top: ${content.topPadding}px;
            padding-bottom: ${content.bottomPadding}px;
          }
        `}
      </style>
    </>
  );
}
